//@flow
// /* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import drawLerc from './draw_lerc_util';
import type Painter from "../../render/painter";
export default drawLercv2;

function drawLercv2(painter: Painter, sourceCache, layer, coords) {
    drawLerc(painter, sourceCache, layer, coords, {
        programName: 'lerc',
        bindOtherParamFunc: bindOtherParamFunc,
    });
}

function bindOtherParamFunc(gl, program, layer) {
    const maskColor = layer.paint.get('mask-color').toVec4();
    const invalidColor = layer.paint.get('invalid-color').toVec4();
    const maskMix = layer.paint.get('mask-mix');
    const isImage = layer.paint.get('is-image');
    gl.uniform4fv(program.uniforms.u_invalid_color, invalidColor);
    gl.uniform4fv(program.uniforms.u_mask_color, maskColor);
    gl.uniform1i(program.uniforms.u_is_image, isImage);
    gl.uniform1f(program.uniforms.u_mask_mix, maskMix);
}
